import {
  Avatar,
  Divider,
  IconButton,
  Modal,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import useStyles from "./styles";
import dayjs from "dayjs";
import { CloseOutlined } from "@mui/icons-material";

export default function ModalDetails(params) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const {
    openDetalhes = false,
    setOpenDetalhes = () => {},
    selectedRow = {},
  } = params;

  return (
    <Modal
      open={openDetalhes}
      onClose={() => {
        setOpenDetalhes(false);
      }}
      sx={styles.modal}
    >
      <Paper sx={styles.paper}>
        {/* informações do usuario */}
        <Box sx={styles.header}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-between",
              flexDirection: "row",
              padding: "20px",
              pb: "4px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                flexDirection: "row",
              }}
            >
              <Avatar src={selectedRow?.user?.foto || ""} sx={styles.avatar} />
              <Typography variant="mySubtitle">
                {selectedRow?.user?.nome} {selectedRow?.user?.sobrenome}
              </Typography>
            </Box>
            <IconButton
              onClick={() => {
                setOpenDetalhes(false);
              }}
            >
              <CloseOutlined />
            </IconButton>
          </Box>
          <Divider />
          <Box sx={styles.headerContent}>
            <Box sx={styles.headerLine}>
              <Box sx={styles.headerItem}>
                <Typography variant="caption" sx={styles.headerSubtitle}>
                  Navegador
                </Typography>
                <Typography sx={styles.headerText}>
                  {selectedRow?.navegador}
                </Typography>
              </Box>
              <Box sx={styles.headerItem}>
                <Typography variant="caption" sx={styles.headerSubtitle}>
                  Sistema
                </Typography>
                <Typography sx={styles.headerText}>
                  {selectedRow?.sistemaOperacional}
                </Typography>
              </Box>
            </Box>
            <Box sx={styles.headerLine}>
              <Box sx={styles.headerItem}>
                <Typography variant="caption" sx={styles.headerSubtitle}>
                  IP
                </Typography>
                <Typography sx={styles.headerText}>
                  {selectedRow?.enderecoIp}
                </Typography>
              </Box>
              {selectedRow?.cliente ? (
                <Box sx={styles.headerItem}>
                  <Typography variant="caption" sx={styles.headerSubtitle}>
                    Cliente
                  </Typography>
                  <Typography sx={styles.headerText}>
                    {selectedRow?.cliente?.nome || ""}
                  </Typography>
                </Box>
              ) : (
                <></>
              )}
            </Box>
            <Box sx={styles.headerItem}>
              <Typography variant="caption" sx={styles.headerSubtitle}>
                Hora
              </Typography>
              <Typography sx={styles.headerText}>
                {dayjs(selectedRow?.createAt).format("DD/MM/YYYY hh:mm:ss")}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Modal>
  );
}
